import { CaseGranulometry } from '../../cases/CaseGranulometry';

export const getLevelId = (caseGranulometry: CaseGranulometry, levelIndex: number): string =>
  'C' + caseGranulometry.labelIndex + 'L' + levelIndex;
